export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  tags: string[];
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  publishedAt: string;
  isHot: boolean;
  isTop: boolean;
  views: number;
  comments: number;
  content: string;
  highlights: string[];
  relatedIds: string[];
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '某顶流男星深夜密会神秘女子，酒店走廊监控视频曝光',
    slug: 'top-star-hotel-scandal',
    excerpt: '近日有网友爆料称拍到某顶流男星深夜与一名神秘女子先后进入某五星级酒店，走廊监控画面清晰可见二人举止亲密，引发全网热议。',
    category: '明星丑闻',
    categorySlug: 'star-scandal',
    tags: ['顶流男星', '酒店', '监控曝光', '出轨'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20hotel%20corridor%20at%20night%20with%20dim%20lighting%2C%20two%20silhouettes%20walking%20closely%20together%2C%20surveillance%20camera%20angle%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20lights%20against%20dark%20background%2C%20film%20grain%20texture%2C%20editorial%20photography&width=800&height=600&seq=article-001&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-07 14:30',
    isHot: true,
    isTop: true,
    views: 1289000,
    comments: 36420,
    content: '',
    highlights: ['"今晚就住这吧，没人会发现"', '"我已经跟经纪人说好了"', '"你确定她不会知道？"'],
    relatedIds: ['article-002', 'article-003', 'article-005', 'article-007'],
  },
  {
    id: 'article-002',
    title: '知名网红情侣分手内幕：男方劈腿多人聊天记录流出',
    slug: 'influencer-breakup-cheating',
    excerpt: '拥有千万粉丝的网红情侣突然官宣分手，随后有知情人曝光男方与多名女生的暧昧聊天记录，内容尺度之大令人咋舌。',
    category: '网红塌房',
    categorySlug: 'influencer-downfall',
    tags: ['网红', '分手', '劈腿', '聊天记录'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20chat%20messages%20with%20blurred%20text%2C%20dark%20room%20with%20warm%20ambient%20light%2C%20dramatic%20lighting%20on%20the%20phone%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography&width=800&height=600&seq=article-002&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-07 12:15',
    isHot: true,
    isTop: false,
    views: 987000,
    comments: 28300,
    content: '',
    highlights: ['"她根本不知道我们的事"', '"你比她有趣多了"', '"周末老地方见"'],
    relatedIds: ['article-001', 'article-004', 'article-006', 'article-008'],
  },
  {
    id: 'article-003',
    title: '女团成员私下辱骂粉丝录音曝光，经纪公司紧急发声明',
    slug: 'girl-group-member-insults-fans',
    excerpt: '一段疑似某女团人气成员私下辱骂粉丝的录音在社交平台疯传，录音中该成员用极其恶劣的言辞评价自己的粉丝群体，引发轩然大波。',
    category: '明星丑闻',
    categorySlug: 'star-scandal',
    tags: ['女团', '辱骂粉丝', '录音', '塌房'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Recording%20studio%20microphone%20in%20dim%20purple%20and%20pink%20lighting%2C%20dramatic%20atmosphere%2C%20music%20recording%20equipment%20with%20colorful%20ambient%20glow%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20soft%20shadows%2C%20editorial%20photography&width=800&height=600&seq=article-003&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-06 22:00',
    isHot: true,
    isTop: false,
    views: 756000,
    comments: 19800,
    content: '',
    highlights: ['"那些粉丝真的很烦人"', '"天天追着我不放"', '"我根本不care他们的感受"'],
    relatedIds: ['article-001', 'article-005', 'article-007', 'article-009'],
  },
  {
    id: 'article-004',
    title: '某知名主播被曝私联多名女粉，金额高达百万级别',
    slug: 'streamer-private-contact-fans',
    excerpt: '直播界再次爆出大瓜！某知名游戏主播被多人联合爆料其通过私信联系多名女粉丝，并以各种理由索要钱财，累计金额惊人。',
    category: '网红塌房',
    categorySlug: 'influencer-downfall',
    tags: ['主播', '私联', '金钱', '诈骗'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20setup%20with%20multiple%20monitors%20in%20dark%20room%2C%20neon%20RGB%20lighting%20in%20pink%20and%20purple%20tones%2C%20dramatic%20atmosphere%2C%20streaming%20equipment%20and%20headphones%2C%20cinematic%20gaming%20room%2C%20editorial%20photography&width=800&height=600&seq=article-004&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-06 18:45',
    isHot: false,
    isTop: false,
    views: 543000,
    comments: 15200,
    content: '',
    highlights: ['"哥最近手头紧，借我点"', '"你是我最特别的那个粉丝"', '"别告诉别人我们的事"'],
    relatedIds: ['article-002', 'article-006', 'article-008', 'article-010'],
  },
  {
    id: 'article-005',
    title: '热播剧男主角被扒假学历，剧组连夜删光相关宣传',
    slug: 'actor-fake-degree-exposed',
    excerpt: '正在热播的某古装剧男主角被知情人士爆料学历造假，声称的海外名校学历实际为短期培训班，剧组已紧急删除所有学历相关宣传物料。',
    category: '明星丑闻',
    categorySlug: 'star-scandal',
    tags: ['演员', '学历造假', '热播剧', '人设崩塌'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20film%20set%20in%20dim%20lighting%2C%20traditional%20costume%20on%20a%20rack%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20spotlight%20on%20fabric%2C%20cinematic%20composition%2C%20editorial%20photography%20with%20dramatic%20shadows&width=800&height=600&seq=article-005&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-06 10:20',
    isHot: true,
    isTop: false,
    views: 892000,
    comments: 25400,
    content: '',
    highlights: ['"学历那个就别提了"', '"反正也没人真去查"', '"培训班也算留学吧"'],
    relatedIds: ['article-001', 'article-003', 'article-007', 'article-009'],
  },
  {
    id: 'article-006',
    title: '某平台头部网红偷税被罚数千万，名下豪车豪宅曝光',
    slug: 'influencer-tax-evasion',
    excerpt: '继多位明星之后，网红圈也爆发税务问题。某平台粉丝过亿的头部网红被税务部门追缴并处罚款数千万元，其名下豪车豪宅随之曝光。',
    category: '网红塌房',
    categorySlug: 'influencer-downfall',
    tags: ['网红', '偷税', '豪车', '豪宅'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20sports%20car%20parked%20in%20front%20of%20modern%20mansion%20at%20night%2C%20dramatic%20lighting%20with%20warm%20golden%20accents%2C%20wealthy%20lifestyle%20scene%2C%20cinematic%20composition%2C%20dark%20sky%20with%20moody%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=article-006&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-05 16:30',
    isHot: false,
    isTop: false,
    views: 634000,
    comments: 18700,
    content: '',
    highlights: ['"税务的事能拖就拖"', '"大不了罚点钱"', '"转移资产要趁早"'],
    relatedIds: ['article-002', 'article-004', 'article-008', 'article-010'],
  },
  {
    id: 'article-007',
    title: '某男星被前女友实锤家暴，医院就诊记录和多段视频流出',
    slug: 'actor-domestic-violence-evidence',
    excerpt: '某二线男星的前女友在社交平台发布长文，控诉其在恋爱期间多次实施家暴，并附上医院就诊记录和多段家中监控视频作为证据。',
    category: '明星丑闻',
    categorySlug: 'star-scandal',
    tags: ['家暴', '前女友', '视频证据', '塌房'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20living%20room%20with%20broken%20glass%20on%20the%20floor%2C%20dim%20warm%20lighting%2C%20disturbed%20and%20chaotic%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20noir%20style%2C%20emotional%20and%20tense%20mood%2C%20editorial%20photography&width=800&height=600&seq=article-007&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-05 09:00',
    isHot: true,
    isTop: false,
    views: 1105000,
    comments: 31200,
    content: '',
    highlights: ['"我实在忍不下去了"', '"每次都说会改"', '"这次绝不原谅"'],
    relatedIds: ['article-001', 'article-003', 'article-005', 'article-009'],
  },
  {
    id: 'article-008',
    title: '某美妆博主被扒用假货冒充正品卖货，粉丝集体维权',
    slug: 'beauty-blogger-fake-products',
    excerpt: '拥有百万粉丝的美妆博主被粉丝爆料其直播间售卖的所谓"正品大牌"实为高仿假货，已有数百名受害者联合发起维权行动。',
    category: '网红塌房',
    categorySlug: 'influencer-downfall',
    tags: ['美妆博主', '假货', '维权', '带货翻车'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20scattered%20on%20a%20vanity%20table%20in%20dark%20dramatic%20lighting%2C%20some%20broken%20lipstick%20and%20powder%2C%20mysterious%20and%20tense%20atmosphere%2C%20warm%20accent%20light%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=600&seq=article-008&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-04 20:15',
    isHot: false,
    isTop: false,
    views: 478000,
    comments: 14300,
    content: '',
    highlights: ['"这个货跟正品一模一样"', '"工厂直供，保证正品"', '"你不懂别乱说"'],
    relatedIds: ['article-002', 'article-004', 'article-006', 'article-010'],
  },
  {
    id: 'article-009',
    title: '某综艺节目被曝剧本操控，淘汰选手怒揭内幕',
    slug: 'reality-show-script-exposed',
    excerpt: '一档热门选秀综艺的淘汰选手在直播中爆料节目全程由剧本操控，所谓"观众投票"实为内定，节目组连夜发律师函警告。',
    category: '明星丑闻',
    categorySlug: 'star-scandal',
    tags: ['综艺', '剧本', '内幕', '选秀'],
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20stage%20backstage%20area%20with%20dramatic%20spotlight%20and%20dark%20shadows%2C%20scripts%20on%20a%20table%2C%20mysterious%20behind%20the%20scenes%20atmosphere%2C%20warm%20purple%20and%20pink%20accent%20lighting%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=600&seq=article-009&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-04 14:00',
    isHot: false,
    isTop: false,
    views: 567000,
    comments: 17200,
    content: '',
    highlights: ['"冠军早就内定了"', '"投票都是做做样子"', '"不服的都被淘汰了"'],
    relatedIds: ['article-001', 'article-003', 'article-005', 'article-007'],
  },
  {
    id: 'article-010',
    title: '某吃播博主被曝假吃催吐，专业医生分析视频实锤',
    slug: 'mukbang-fake-eating-exposed',
    excerpt: '人气吃播博主被网友逐帧分析其视频，专业消化科医生出面指出多处假吃和催吐痕迹，该博主账号已设为私密。',
    category: '网红塌房',
    categorySlug: 'influencer-downfall',
    tags: ['吃播', '假吃', '催吐', '翻车'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Table%20full%20of%20colorful%20food%20in%20dark%20room%20with%20dramatic%20overhead%20lighting%2C%20streaming%20camera%20setup%20in%20background%2C%20mysterious%20mood%20with%20warm%20accent%20lights%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=600&seq=article-010&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-03 19:30',
    isHot: false,
    isTop: false,
    views: 345000,
    comments: 9800,
    content: '',
    highlights: ['"这镜头切换明显有问题"', '"吃进去的全吐了"', '"欺骗观众太可耻"'],
    relatedIds: ['article-002', 'article-004', 'article-006', 'article-008'],
  },
  {
    id: 'article-011',
    title: '两顶流女星片场互扇耳光视频流出，剧组陷入停摆',
    slug: 'actresses-fight-on-set',
    excerpt: '某大制作剧组爆出惊人内幕，两位当红女星因番位之争在片场爆发激烈冲突，从口角升级为肢体冲突，导致拍摄全面暂停。',
    category: '明星丑闻',
    categorySlug: 'star-scandal',
    tags: ['女星', '片场', '打架', '番位'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20clapperboard%20in%20dim%20dramatic%20lighting%2C%20two%20spotlights%20crossing%20in%20the%20darkness%2C%20tense%20atmosphere%2C%20warm%20golden%20and%20pink%20accents%2C%20cinematic%20noir%20composition%2C%20editorial%20photography&width=800&height=600&seq=article-011&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-07 08:00',
    isHot: true,
    isTop: false,
    views: 1456000,
    comments: 42100,
    content: '',
    highlights: ['"我才是女一号"', '"你算什么东西"', '"导演你说句话啊"'],
    relatedIds: ['article-001', 'article-003', 'article-005', 'article-007'],
  },
  {
    id: 'article-012',
    title: '某短视频平台大V被扒出十年前黑历史，连夜删号跑路',
    slug: 'influencer-past-exposed',
    excerpt: '一位近期爆火的短视频大V被网友扒出其十年前在社交平台发布的大量不当言论和照片，该大V在舆论发酵后连夜注销所有账号。',
    category: '网红塌房',
    categorySlug: 'influencer-downfall',
    tags: ['短视频', '黑历史', '删号', '翻车'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20social%20media%20delete%20confirmation%20screen%20in%20dark%20room%2C%20dramatic%20warm%20lighting%2C%20tense%20mood%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography&width=800&height=600&seq=article-012&orientation=landscape',
    imageWidth: 800,
    imageHeight: 600,
    publishedAt: '2026-07-06 23:59',
    isHot: true,
    isTop: false,
    views: 823000,
    comments: 22900,
    content: '',
    highlights: ['"那时候年轻不懂事"', '"早就想过会有这一天"', '"互联网是有记忆的"'],
    relatedIds: ['article-002', 'article-004', 'article-006', 'article-008'],
  },
];

export const categories = [
  {
    slug: 'star-scandal',
    name: '明星丑闻',
    icon: 'ri-star-line',
    description: '明星塌房、人设崩塌、恋情曝光、丑闻黑料一网打尽',
    imageUrl: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20dramatic%20paparazzi%20flash%20lighting%2C%20dark%20moody%20atmosphere%2C%20celebrity%20entrance%20scene%2C%20warm%20golden%20and%20pink%20accent%20lights%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20glamorous%20yet%20mysterious&width=800&height=500&seq=cat-star-scandal&orientation=landscape',
    imageWidth: 800,
    imageHeight: 500,
  },
  {
    slug: 'influencer-downfall',
    name: '网红塌房',
    icon: 'ri-user-unfollow-line',
    description: '网红翻车、直播事故、带货翻车、人设崩塌全记录',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%20and%20camera%20in%20dark%20room%2C%20dramatic%20pink%20and%20purple%20neon%20lighting%2C%20mysterious%20atmosphere%2C%20streaming%20equipment%20setup%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=500&seq=cat-influencer&orientation=landscape',
    imageWidth: 800,
    imageHeight: 500,
  },
  {
    slug: 'leaked-chats',
    name: '泄露聊天',
    icon: 'ri-chat-smile-2-line',
    description: '聊天记录泄露、私密对话曝光、暧昧信息实锤',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20chat%20bubbles%20in%20dark%20room%2C%20dramatic%20warm%20lighting%20on%20the%20phone%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20tense%20atmosphere&width=800&height=500&seq=cat-chats&orientation=landscape',
    imageWidth: 800,
    imageHeight: 500,
  },
  {
    slug: 'contrast-video',
    name: '反差视频',
    icon: 'ri-contrast-2-line',
    description: '人前人后反差、虚假人设对比、真实面目大揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20visual%20concept%20with%20bright%20glamorous%20side%20and%20dark%20hidden%20side%2C%20dramatic%20contrast%20lighting%2C%20duality%20theme%2C%20warm%20and%20cold%20colors%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20mysterious%20mood&width=800&height=500&seq=cat-contrast&orientation=landscape',
    imageWidth: 800,
    imageHeight: 500,
  },
];

export const testimonials = [
  {
    quote: '在91吃瓜网看到了太多平时看不到的真相，每一个瓜都有实锤证据，比那些只会捕风捉影的营销号强太多了。',
    author: '资深吃瓜群众',
    verified: true,
  },
  {
    quote: '每天打开手机第一件事就是来91吃瓜网看看今天又有什么新瓜，更新速度快得离谱，关键是料都特别真！',
    author: '瓜田里的猹',
    verified: true,
  },
  {
    quote: '之前朋友推荐来的，一开始还不信，结果发现这里的瓜都是有图有真相，聊天记录、视频、截图一应俱全。',
    author: '吃瓜一线',
    verified: true,
  },
];

export const faqItems = [
  {
    question: '91在线吃瓜网的内容来源是否可靠？',
    answer: '我们所有爆料内容均来源于公开网络渠道和知情人士投稿，每一篇爆料文章都会附上原始素材截图或视频链接供读者自行判断。我们秉持"有图有真相"的原则，不发布未经证实的纯文字谣言。',
  },
  {
    question: '如何向91在线吃瓜网投稿爆料？',
    answer: '您可以通过"关于我们"页面中的联系方式或网站底部邮箱向我们投稿。我们承诺对所有爆料人信息严格保密，并会根据爆料内容的质量给予相应奖励。',
  },
  {
    question: '吃瓜视频如何免费观看？',
    answer: '网站上的所有内容均为免费，包括视频、图文、聊天记录截图等。您可以通过首页"线路一"入口或文章详情页的播放按钮直接观看，无需注册或付费。',
  },
  {
    question: '为什么某些文章或视频被删除了？',
    answer: '如遇到文章或视频无法访问的情况，可能是由于当事人或相关方通过法律途径要求删除，我们会在收到有效法律文件后依法处理。您可以关注我们的社交媒体账号获取最新动态。',
  },
  {
    question: '91在线吃瓜网有APP吗？',
    answer: '我们的吃瓜APP正在开发中，敬请期待！目前您可以通过手机浏览器访问我们的网站获得完整的移动端体验。您也可以在首页订阅我们的更新通知，第一时间获取最新爆料。',
  },
];